import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getUserLoggedInStatus } from 'Components/app/ducks/selectors';
import { getCurrentVehicleId } from 'Components/vehicle/ducks/selectors';
import Sidebar from './sidebar';

const mapStateToProps = state => ({
  isLoggedIn: getUserLoggedInStatus(state),
  ...getCurrentVehicleId(state)
});

export default compose(
  withRouter,
  connect(mapStateToProps)
)(Sidebar);
